import {
  SocketData,
  AddReactionMessage,
  ReplacedReactionMessage,
  RemovedReactionMessage,
  ReadReactionMessage,
} from 'actions/socket/socketReceiveDataAction'
import { CustomPhoto } from 'api/photo/photo.types'
import {
  MessengerItemTypes,
  SUPPORT_BOT_PROFILE_ID,
} from 'components/page/Chat/Messenger/Messenger.constants'
import {
  convertDateFromUnixTimeStampToISOString,
  prepareMessagesStructure,
} from 'components/page/Chat/Messenger/Messenger.functions'
import {
  ChatMessage,
  ChatMessengerState,
} from 'reducers/messenger/ChatMessengerState'

export const checkIsSupportChat = (profileId: number) =>
  profileId === SUPPORT_BOT_PROFILE_ID

export const handleMessagesProgressiveLoading = (
  requestMessages: ChatMessage[] = [],
  stateMessages: ChatMessage[],
  loadMoreOld,
  loadMoreNew
): ChatMessage[] => {
  if (loadMoreOld && loadMoreNew) {
    console.error('should be only one direction of progressive loading!')
    return stateMessages
  }

  if (!loadMoreOld && !loadMoreNew) {
    return requestMessages
  }

  if (loadMoreOld) {
    return stateMessages.concat(requestMessages)
  }

  if (loadMoreNew) {
    return stateMessages
  }
  return []
}

export const markAllMessagesAsReaded = (updatedMessages: ChatMessage[]) => {
  for (const message of updatedMessages) {
    if (message.unread) {
      message.unread = false
    } else {
      break
    }
  }

  return updatedMessages
}

export const addToArrayPhoto = (state: CustomPhoto[], photo: CustomPhoto) => {
  const isExist = state.some((item) => item.photoId === photo.photoId)

  if (!isExist) {
    return [...state, photo]
  }

  return state.filter((item) => item.photoId !== photo.photoId)
}

/** Создает фейковое сообщение, которое не отправилось из-за стопчата */
export const createFailedMessage = (
  state: ChatMessengerState,
  messageText: string
): ChatMessage => {
  const createdTs = new Date().getTime() / 1000

  return {
    id: state.messages.length,
    incoming: false,
    user_to_id: state.selectedProfileId,
    type: MessengerItemTypes.Failed,
    createdTs,
    created: convertDateFromUnixTimeStampToISOString(createdTs),
    message: messageText,
    message_text: messageText,
    unread: true,
    repliedMessage: state.messages.find(
      ({ id }) => id === state.replyMessageId
    ),
    user_from_id: 0,
    folder_to_id: 0,
    contact_id: '0',
    last_edit_date: null,
    uuid: '',
  }
}

export const updateMessagesWithAddedReaction = (
  chatState: ChatMessengerState,
  addedReaction: SocketData<AddReactionMessage>['content']
): ChatMessengerState => {
  const messages = chatState.messages.map((message) => {
    if (message.uuid !== addedReaction.messageUuid) {
      return message
    }

    const { userId, id, type, value, createdAt } = addedReaction

    // Проверим, нет ли случайно реакции от этого пользователя
    if (message.reactions?.find((reaction) => reaction.userId === userId)) {
      return {
        ...message,
        reactions: message.reactions.map((reaction) => {
          if (reaction.userId === userId) {
            return { userId, id, type, value, createdAt, readAt: null }
          }

          return reaction
        }),
      }
    }

    return {
      ...message,
      reactions: [
        ...message.reactions!,
        { userId, id, type, value, createdAt, readAt: null },
      ],
    }
  })

  return {
    ...chatState,
    messages,
    messagesByDays: prepareMessagesStructure(messages),
  }
}

export const updateMessagesWithReplacedReaction = (
  chatState: ChatMessengerState,
  replacedReaction: SocketData<ReplacedReactionMessage>['content']
) => {
  const messages = chatState.messages.map((message) => {
    if (message.uuid !== replacedReaction.messageUuid) {
      return message
    }

    const updatedReactions = message.reactions!.map((reaction) => {
      if (
        reaction.id === replacedReaction.oldId &&
        reaction.userId === replacedReaction.userId
      ) {
        const { id, type, value, userId, createdAt } = replacedReaction
        return { id, type, value, userId, createdAt, readAt: null }
      }

      return reaction
    })

    return {
      ...message,
      reactions: updatedReactions,
    }
  })

  return {
    ...chatState,
    messages,
    messagesByDays: prepareMessagesStructure(messages),
  }
}

export const updateMessagesWithRemovedReaction = (
  chatState: ChatMessengerState,
  removedReaction: SocketData<RemovedReactionMessage>['content']
) => {
  const messages = chatState.messages.map((message) => {
    if (message.uuid === removedReaction.messageUuid) {
      return {
        ...message,
        reactions: message.reactions!.filter((reaction) => {
          if (
            reaction.id === removedReaction.id &&
            reaction.userId === removedReaction.userId
          ) {
            return false
          }
          return true
        }),
      }
    }

    return message
  })

  return {
    ...chatState,
    messages,
    messagesByDays: prepareMessagesStructure(messages),
  }
}

export const updateMessagesWithReadReaction = (
  chatState: ChatMessengerState,
  readReaction: SocketData<ReadReactionMessage>['content']
) => {
  const messages = chatState.messages.map((message) => {
    if (message.uuid === readReaction.messageUuid) {
      return {
        ...message,
        reactions: message.reactions!.map((reaction) => {
          if (
            reaction.id === readReaction.id &&
            reaction.userId === readReaction.userId
          ) {
            return { ...reaction, readAt: readReaction.readAt }
          }
          return reaction
        }),
      }
    }

    return message
  })

  return {
    ...chatState,
    messages,
    messagesByDays: prepareMessagesStructure(messages),
  }
}
